import React from 'react';

// Constellation Components
import {
    Input,
} from '@zillow/constellation';

/* WARNING
/* this should never be used directly.
/* it is rendered via <ImageContainer isBackgroundImage />
*/

const BackgroundImage = props => (
    <Input
        aria-label={props.altText}
        style={{
            backgroundImage: `url(${props.src})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: props.backgroundSize,
            width: '100%',
            height: '100%',
        }}
        title={props.altText}
        onClick={props.onClick}
        onKeyDown={props.onKeyDown}
    />
);

export default BackgroundImage;
